import { render, staticRenderFns } from "./Main.Loader.vue?vue&type=template&id=3931922e&scoped=true&"
import script from "./Main.Loader.vue?vue&type=script&lang=js&"
export * from "./Main.Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3931922e",
  null
  
)

export default component.exports